import { render } from "./PopupDeactivateContract.vue?vue&type=template&id=78a767d0"
import script from "./PopupDeactivateContract.vue?vue&type=script&lang=js"
export * from "./PopupDeactivateContract.vue?vue&type=script&lang=js"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__